const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-compete');
const Show = resolve => require.ensure([], () => resolve(require('./Show.vue')), 'group-compete');
const Mark = resolve => require.ensure([], () => resolve(require('./Mark.vue')), 'group-compete');

export default [{
  path: '/expert/compete/projects',
  name: 'expert_compete_project_index',
  component: Index,
  meta: {
    title: '比赛管理',
    layout: 'center',
  },
}, {
  path: '/expert/compete/projects/:id',
  name: 'expert_compete_project_show',
  component: Show,
  meta: {
    title: '比赛作品',
    layout: 'center',
  },
}, {
  path: '/expert/compete/marks/:id',
  name: 'expert_compete_mark_show',
  component: Mark,
  meta: {
    title: '比赛作品评分',
    layout: 'center',
  },
}];



// WEBPACK FOOTER //
// ./src/pages/expert/compete/index.js